<form #form="ngForm">
    <div class="transport-details">
        <app-checkbox decorator="right-side" #customerCheckbox name="customer-transport-active" [caption]="'Use your SFTP solution'" [ngModel]="!!customerTransport()" (ngModelChange)="customerActiveChanged($event)" [disabled]="disabled()"></app-checkbox>
        @if (!!customerTransport()) {
            <app-sftp-transport-viewer name="customer-transport" [ngModel]="customerTransport()" (ngModelChange)="updateTransport($event)" [disabled]="disabled()"></app-sftp-transport-viewer>
        }
    </div>

    <div class="transport-details">
        <app-checkbox decorator="right-side" #partnerCheckbox name="partner-transport-active" [caption]="'Use your partners SFTP solution'" [ngModel]="!!partnerTransport()" (ngModelChange)="partnerActiveChanged($event)" [disabled]="disabled()"></app-checkbox>
        @if (!!partnerTransport()) {
            <app-sftp-transport-viewer name="partner-transport" [ngModel]="partnerTransport()" (ngModelChange)="updateTransport($event)" [disabled]="disabled()"></app-sftp-transport-viewer>
        }
    </div>
</form>
